import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

export default function PrivateRoute() {
    const { isLoggedIn, loading } = useAuth();

    if (loading)
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin" />
            </div>
        );

    return isLoggedIn ? <Outlet /> : <Navigate to="/login" replace />;
}
